<template>
  <header class="sub-header">
    <Breadcrumbs />
  </header>
</template>

<script>
import Breadcrumbs from '@/components/layout/header/Breadcrumbs.vue';

export default {
  name: 'SubHeader',
  components: { Breadcrumbs },
};
</script>

<style lang="scss" scoped>
  header.sub-header {
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background-color: var(--accent-bg-hex);
      opacity: var(--sub-menu-opacity);
      position: absolute;
    }

    position: relative;
    display: grid;
    align-items: center;
    background-color: var(--background-bg-hex);
    padding: 0 10px;
    border-bottom: 1px solid rgba(var(--accent-bg-rgb), 0.1);
    z-index: 1;
  }
</style>
